import { render, staticRenderFns } from "./totalRank.vue?vue&type=template&id=a7586cd0&scoped=true&"
import script from "./totalRank.vue?vue&type=script&lang=js&"
export * from "./totalRank.vue?vue&type=script&lang=js&"
import style0 from "./totalRank.vue?vue&type=style&index=0&id=a7586cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7586cd0",
  null
  
)

export default component.exports